var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',[_c('v-toolbar',{attrs:{"color":"primary","dark":"","flat":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('details')))])],1),_c('v-card-text',[_c('campaign-details',{ref:"campaignDetails",attrs:{"campaign":_vm.campaign,"restricted-editing":_vm.restrictedEditing}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }